module.exports = __webpack_public_path__ + "media/images/black-caret-6925581e84acd5319927ca39f3da18db.svg";